<link rel="ractive" href="./slider.html" name="c-slider">
<link rel="ractive" href="./slide.html" name="c-slide">

<div class="c-landing-top">
	<div class="content">
		<section class="heading">
			<span>Fast. Reliable. Automated.</span>
			<h1>A free CDN for open source projects</h1>
			<p>Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats.</p>
			<span>Operating since 2012.</span>
		</section>

		<section class="stats">
			<div>
				<h3>{{_.formatHits(networkStats.hits.total)}} billion requests</h3>
				<span>past month</span>
			</div>
			<div>
				<h3>over {{_.formatBytesWithUnit(networkStats.bandwidth.total, 'TB')}}</h3>
				<span>past month</span>
			</div>
		</section>
	</div>
	<div class="container-fluid container-mw">
		<div class="row">
			<div class="col-xs-12 col-lg-10 col-lg-push-1">
				<section class="docs">
					<div class="docs_tabs">
						<div class="docs_tabs_wrapper">
							<div class="docs_tabs_tab {{#unless activeDocs}}active-docs-tab{{/unless}}">
								<a on-click="@this.set('activeDocs', '')" class="{{#unless activeDocs}}active{{/unless}}">
									<img width="50" height="14" src="{{@shared.assetsHost}}/img/landing/new/docs-code/npm.svg">
								</a>
							</div>

							<div class="docs_tabs_tab {{#if activeDocs === 'esm'}}active-docs-tab{{/if}}">
								<a on-click="@this.set('activeDocs', 'esm')" class="{{#if activeDocs === 'esm'}}active{{/if}}">
									<img width="44" height="17" src="{{@shared.assetsHost}}/img/landing/new/docs-code/esm.svg">
								</a>
							</div>

							<div class="docs_tabs_tab {{#if activeDocs === 'gh'}}active-docs-tab{{/if}}">
								<a on-click="@this.set('activeDocs', 'gh')" class="{{#if activeDocs === 'gh'}}active{{/if}}">
									<img width="67" height="19" src="{{@shared.assetsHost}}/img/landing/new/docs-code/github.svg">
								</a>
							</div>

							<div class="docs_tabs_tab {{#if activeDocs === 'wp'}}active-docs-tab{{/if}}">
								<a on-click="@this.set('activeDocs', 'wp')" class="{{#if activeDocs === 'wp'}}active{{/if}}">
									<img width="107" height="22" src="{{@shared.assetsHost}}/img/landing/new/docs-code/wordpress.svg">
								</a>
							</div>

							<div class="active-tab-line" style="left: {{activeDocsLineLeft}}%"></div>
						</div>

						<div class="dropdown">
							<button class="dropdown-toggle" type="button" id="cdn-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
								<div class="selected">
									<img src="{{ @shared.assetsHost }}/img/landing/new/docs-code/{{ cdnsList[activeDocsIndex].image }}">
								</div>
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/chevron-down.white.svg" loading="lazy"/>
							</button>

							<ul class="dropdown-menu" aria-labelledby="cdn-dropdown">
								{{#each ~/cdnsList}}
									{{ #if activeDocs !== .slug }}
										<li>
											<a on-click="@this.set('activeDocs', .slug)">
												<img src="{{ @shared.assetsHost }}/img/landing/new/docs-code/{{ .image }}">
											</a>
										</li>
									{{ /if }}
								{{/each}}
							</ul>
						</div>
					</div>

					<div class="docs_code">
						<c-slider active="{{activeSlide}}" direction="horizontal" distance="400" duration="400">
							{{#each slidesData:slideIdx}}
								<c-slide>
									<div class="docs_code_slide" id="{{slideIdx}}">
										{{#each this:idx}}
											{{#each this.comments}}
												<p class="docs-comment">{{this}}</p>
											{{/each}}

											{{#each this.links}}
												<p class="docs-link">
													<a target="_blank" rel="noopener noreferrer" href="{{this}}">
														{{this}}
													</a>
												</p>
											{{/each}}

											{{#unless idx === slidesData[slideIdx].length -1}}
												<br>
											{{/unless}}
										{{/each}}
									</div>
								</c-slide>
							{{/each}}
						</c-slider>
					</div>

					<a class="btn-docview btn-grey btn-sm" href="/documentation">
						<img src="{{ @shared.assetsHost }}/img/icons/info_circle.svg">Full docs
					</a>
				</section>

				<section class="sponsors">
					<span>jsDelivr operates thanks to our main sponsors:</span>

					<div class="sponsors-logos">
						<div class="sponsors-logos_item">
							<a target="_blank" rel="noopener noreferrer" href="https://www.cloudflare.com">
								<img width="149"
									height="50"
									src="{{@shared.assetsHost}}/img/landing/cloudflare.png"
									srcset="{{@shared.assetsHost}}/img/landing/cloudflare@2x.png 2x"
									title="Sponsored by Cloudflare">
							</a>
						</div>

						<div class="sponsors-logos_item">
							<a target="_blank" rel="noopener noreferrer" href="https://www.fastly.com">
								<img width="116"
									height="50"
									src="{{@shared.assetsHost}}/img/landing/fastly.png"
									srcset="{{@shared.assetsHost}}/img/landing/fastly@2x.png 2x"
									title="Sponsored by Fastly">
							</a>
						</div>

						<div class="sponsors-logos_item">
							<a target="_blank" rel="noopener noreferrer" href="https://gcore.com/">
								<img width="409"
									height="116"
									src="{{@shared.assetsHost}}/img/landing/new/gcorelabs.svg"
									title="Sponsored by G-Core Labs">
							</a>
						</div>

						<div class="sponsors-logos_item">
							<a target="_blank" rel="noopener noreferrer" href="https://www.ibm.com/products/ns1-connect">
								<img width="125"
									height="50"
									src="{{@shared.assetsHost}}/img/landing/ibm.svg"
									title="Sponsored by IBM NS1 Connect">
							</a>
						</div>

						<div class="sponsors-logos_item">
							<a target="_blank" rel="noopener noreferrer" href="https://render.com/">
								<img width="262"
									height="50"
									src="{{@shared.assetsHost}}/img/sponsors/render-black.svg"
									title="Sponsored by render.com">
							</a>
						</div>

						<div class="sponsors-logos_item">
							<a target="_blank" rel="noopener noreferrer" href="https://bunny.net">
								<img width="172"
									height="50"
									src="{{@shared.assetsHost}}/img/landing/bunny.png"
									srcset="{{@shared.assetsHost}}/img/landing/bunny@2x.png 2x"
									title="Sponsored by bunny.net">
							</a>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const docs = [ '', 'esm', 'gh', 'wp' ];

	component.exports = {
		noIntro: true,
		computed: {
			activeDocsLineLeft () {
				return this.get('activeSlide') * 25;
			},
			activeDocsIndex () {
				return docs.indexOf(this.get('activeDocs'));
			},
		},
		data () {
			return {
				_,
				activeDocs: '',
				networkStats: {
					hits: {
						total: 15e10,
					},
					bandwidth: {
						total: 5e15,
					},
				},
				cdnsList: [
					{ slug: '', label: 'npm', image: 'npm.svg' },
					{ slug: 'esm', label: 'esm', image: 'esm.svg' },
					{ slug: 'gh', label: 'GitHub', image: 'github.svg' },
					{ slug: 'wp', label: 'WordPress', image: 'wordpress.svg' },
				],
				slidesData: {
					slide1:	[
						{
							comments: [
								'// load any project hosted on npm',
							],
							links: [
								'https://cdn.jsdelivr.net/npm/package@version/file',
							],
						},
						{
							comments: [
								'// load jQuery v3.6.4',
							],
							links: [
								'https://cdn.jsdelivr.net/npm/jquery@3.6.4/dist/jquery.min.js',
							],
						},
						{
							comments: [
								'// use a version range instead of a specific version',
							],
							links: [
								'https://cdn.jsdelivr.net/npm/jquery@3.6/dist/jquery.min.js',
								'https://cdn.jsdelivr.net/npm/jquery@3/dist/jquery.min.js',
							],
						},
						{
							comments: [
								'// omit the version completely to get the latest one',
								'// you should NOT use this in production',
							],
							links: [
								'https://cdn.jsdelivr.net/npm/jquery/dist/jquery.min.js',
							],
						},
						{
							comments: [
								'// add ".min" to any JS/CSS file to get a minified version',
								'// if one doesn\'t exist, we\'ll generate it for you',
							],
							links: [
								'https://cdn.jsdelivr.net/npm/jquery@3.6.4/src/core.min.js',
							],
						},
						{
							comments: [
								'// omit the file path to get the default file',
							],
							links: [
								'https://cdn.jsdelivr.net/npm/jquery@3.6',
							],
						},
						{
							comments: [
								'// add / at the end to get a directory listing',
							],
							links: [
								'https://cdn.jsdelivr.net/npm/jquery/',
							],
						},
					],
					slide2:	[
						{
							comments: [
								'// load any project hosted on npm',
							],
							links: [
								'https://esm.run/package@version/file',
							],
						},
						{
							comments: [
								'// load d3 v7.8.3',
							],
							links: [
								'https://esm.run/d3@7.8.3',
							],
						},
						{
							comments: [
								'// use a version range instead of a specific version',
							],
							links: [
								'https://esm.run/d3@7.8',
								'https://esm.run/d3@7',
							],
						},
						{
							comments: [
								'// omit the version completely to get the latest one',
								'// you should NOT use this in production',
							],
							links: [
								'https://esm.run/d3',
							],
						},
						{
							comments: [
								'// load a non-default file',
							],
							links: [
								'https://esm.run/d3/dist/d3.js',
							],
						},
						{
							comments: [
								'// all packages are automatically bundled and minified',
							],
						},
					],
					slide3: [
						{
							comments: [
								'// load any GitHub release, commit, or branch',
								'// note: we recommend using npm for projects that support it',
							],
							links: [
								'https://cdn.jsdelivr.net/gh/user/repo@version/file',
							],
						},
						{
							comments: [
								'// load jQuery v3.6.4',
							],
							links: [
								'https://cdn.jsdelivr.net/gh/jquery/jquery@3.6.4/dist/jquery.min.js',
							],
						},
						{
							comments: [
								'// use a version range instead of a specific version',
							],
							links: [
								'https://cdn.jsdelivr.net/gh/jquery/jquery@3.6/dist/jquery.min.js',
								'https://cdn.jsdelivr.net/gh/jquery/jquery@3/dist/jquery.min.js',
							],
						},
						{
							comments: [
								'// omit the version completely to get the latest one',
								'// you should NOT use this in production',
							],
							links: [
								'https://cdn.jsdelivr.net/gh/jquery/jquery/dist/jquery.min.js',
							],
						},
						{
							comments: [
								'// add ".min" to any JS/CSS file to get a minified version',
								'// if one doesn\'t exist, we\'ll generate it for you',
							],
							links: [
								'https://cdn.jsdelivr.net/gh/jquery/jquery@3.6.4/src/core.min.js',
							],
						},
						{
							comments: [
								'// add / at the end to get a directory listing',
							],
							links: [
								'https://cdn.jsdelivr.net/gh/jquery/jquery/',
							],
						},
					],
					slide4: [
						{
							comments: [
								'// load any plugin from the WordPress.org plugins SVN repo',
							],
							links: [
								'https://cdn.jsdelivr.net/wp/plugins/project/tags/version/file',
							],
						},
						{
							comments: [
								'// load an exact version',
							],
							links: [
								'https://cdn.jsdelivr.net/wp/plugins/wp-slimstat/tags/4.6.5/wp-slimstat.js',
							],
						},
						{
							comments: [
								'// load the latest version',
								'// you should NOT use this in production',
							],
							links: [
								'https://cdn.jsdelivr.net/wp/plugins/wp-slimstat/trunk/wp-slimstat.js',
							],
						},
						{
							comments: [
								'// load any theme from the WordPress.org themes SVN repo',
							],
							links: [
								'https://cdn.jsdelivr.net/wp/themes/project/version/file',
							],
						},
						{
							comments: [
								'// load an exact version',
							],
							links: [
								'https://cdn.jsdelivr.net/wp/themes/twenty-eightteen/1.7/assets/js/html5.js',
							],
						},
						{
							comments: [
								'// add ".min" to any JS/CSS file to get a minified version',
								'// if one doesn\'t exist, we\'ll generate it for you',
							],
							links: [],
						},
					],
				},
				docsSlideTopHeight: 0,
			};
		},
		oninit () {
			// It's too soon to call the show method here.
			this.findComponent('c-slider').set('active', docs.indexOf(this.get('activeDocs')) !== -1 ? docs.indexOf(this.get('activeDocs')) : 0);

			if (!Ractive.isServer) {
				this.observe('activeDocs', (newValue) => {
					this.findComponent('c-slider').show(docs.indexOf(newValue) !== -1 ? docs.indexOf(newValue) : 0);
				}, { init: false });

				// Load network stats.
				http.fetchNetworkStats().then((data) => {
					this.animate('networkStats', data);
				});
			}
		},
	};
</script>
